// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dcc69caf","952":"458a2f1a"}[chunkId] + ".chunk.js";
};